module.exports = __webpack_public_path__ + "static/media/ig-logo.e297156b.svg";